// "Mais": o que não cabe nas abas (acertos, despesas, a pagar, a receber, contas fixas,
// relatórios, clientes, conta, usuários, alterações não enviadas).
import { h, icone } from '../lib/dom.js';
import { estado } from '../local/sincronia.js';
import { sessao } from '../sessao.js';
import { casca } from '../ui/casca.js';
import { cartaoLink, secao } from '../ui/componentes.js';

export function telaMais() {
  const e = sessao.empresa;
  const pendentes = estado.pendentes + estado.recusadas;
  return casca({
    titulo: 'Mais',
    conteudo: h('div', { class: 'secao' },
      secao('Dinheiro', h('div', { class: 'lista' },
        cartaoLink({ href: '#/acertos', simbolo: 'pessoas', titulo: 'Acertos', linhas: ['Comissão, vales e despesas de cada colaborador'] }),
        cartaoLink({ href: '#/despesas', simbolo: 'recibo', titulo: 'Despesas', linhas: ['Diesel, manutenção e outros gastos, mês a mês'] }),
        cartaoLink({ href: '#/apagar', simbolo: 'dinheiro', titulo: 'A pagar', linhas: ['Parcelas, contas do mês e agenciamentos'] }),
        cartaoLink({ href: '#/areceber', simbolo: 'dinheiro', titulo: 'A receber', linhas: ['Adiantamentos e saldos de frete, comprovantes para postar'] }),
        cartaoLink({ href: '#/contas-fixas', simbolo: 'calendario', titulo: 'Contas fixas', linhas: ['Seguro, rastreador, financiamento… lançados todo mês'] }))),
      secao('Relatórios', h('div', { class: 'lista' },
        cartaoLink({ href: '#/relatorios', simbolo: 'grafico', titulo: 'Relatórios', linhas: ['Custo por km dos caminhões, remuneração por pessoa, contador e acertos'] }))),
      secao('Cadastros', h('div', { class: 'lista' },
        cartaoLink({ href: '#/clientes', simbolo: 'clientes', titulo: 'Clientes', linhas: ['Contratantes das cargas e prazo do saldo'] }),
        cartaoLink({ href: '#/oficinas', simbolo: 'chave', titulo: 'Oficinas de confiança', linhas: ['Borracharias, mecânicas e guinchos que o SOS mostra primeiro'] }))),
      secao('Estrada', h('div', { class: 'lista' },
        cartaoLink({ href: '#/raiox', simbolo: 'rota', titulo: 'Raio-X do frete', linhas: ['Antes de aceitar: piso da ANTT, custo, quanto pedir e o que tem de volta'] }),
        cartaoLink({ href: '#/manutencao', simbolo: 'chave', titulo: 'Manutenção preventiva', linhas: ['Óleo, filtros, graxa, freios…: o que vence pelo km ou pelo tempo'] }),
        cartaoLink({ href: '#/sos', simbolo: 'alerta', titulo: 'SOS mecânica', linhas: ['Oficinas perto do caminhão, com Ligar, WhatsApp e Rota'] }))),
      secao('Conta', h('div', { class: 'lista' },
        cartaoLink({ href: '#/conta', simbolo: 'conta', titulo: 'Conta e empresa', linhas: [e?.nome_fantasia || e?.nome, 'Dados da empresa, assinatura, cópia dos dados e sair'] }),
        cartaoLink({ href: '#/usuarios', simbolo: 'pessoas', titulo: 'Usuários', linhas: ['Quem usa a conta: escritório e contador'] }),
        pendentes > 0 && cartaoLink({
          href: '#/pendencias',
          simbolo: 'alerta',
          titulo: 'Alterações não enviadas',
          linhas: [estado.recusadas > 0 ? `${estado.recusadas} não aceita(s) pelo servidor` : `${pendentes} esperando sinal`],
        }))),
      secao('Ajuda', h('div', { class: 'lista' },
        cartaoLink({ href: '#/ajuda', simbolo: 'ajuda', titulo: 'Ajuda', linhas: ['Dúvidas comuns, com o nome dos botões, e o contato do HSA Frota'] }))),
      h('p', { class: 'pequeno' }, icone('caminhao', { tamanho: 16 }), ` HSA Frota · versão ${__VERSAO__}`)),
  });
}
